
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.588 24.606v-1-.6c0-3.1 1-8.7-2.6-10.2-1.3-.5-3-.2-4.3-.2h-1.7v-3c0-.4-.1-1.6-.7-1.6s-.7 1.2-.7 1.6v3h-6.7c-3.4 0-7-.3-10.6-.3v-2.7c0-.4-.1-1.6-.7-1.6-.6-.1-.7 1.1-.7 1.5v2.7c-1.5 0-3 .1-4.4.3-4.3.5-4.2 4.2-4.2 7.6v19.5c0 2.9-1.2 9.4 1.3 11.8 1.4 1.4 3.3 1.1 5 1.1H44.788c.1 0 .1 0 .2-.1 4.5-1.1 3.6-6 3.6-9.6v-18.2zm-35.9-7.3c.9-2 4.4-2.1 7.3-1.9v3.2c0 .4.1 1.6.7 1.6s.7-1.2.7-1.6v-3.1c.8.1 1.5.1 1.9.1h15.3v3c0 .4.1 1.6.7 1.6s.7-1.2.7-1.6v-3c1.4 0 3.1-.3 4.4 0 3.1.6 2.4 1.3 2.8 3.2.2 1.2.3 2.4.4 3.7h-34.9v-.7c0-1.2-.5-3.4 0-4.5zm32.1 32.1h-26.6c-.9 0-2.2.2-3.1 0-3.1-.8-2.4-2.2-2.4-4.5v-15.8-3.5h34.9c-.1 3.3-.4 6.8-.4 9.8 0 3.2 1.9 13.2-2.4 14z"}})])
          )
        }
      }
    